export function all (state) {
	return state.competitions;
}
